<template>
  <div class="info-layout">
    <ui-field
      class="company-name-field"
      label-position="inline"
      :label="$t('identification_company_name')"
      bottom-margin="small"
    >
      <span class="company-name">{{ companyName }}</span>
    </ui-field>
    <ui-field
      label-position="inline"
      :label="$t('identification_status')"
      bottom-margin="small"
    >
      {{ identificationStatus }}
    </ui-field>
    <ui-field
      v-if="rejectionReason"
      label-position="inline"
      :label="
        $t('compliance_reviews.submissionForComplianceReviews.rejectionReason')
      "
      bottom-margin="small"
    >
      {{ rejectionReason }}
    </ui-field>
    <ui-field
      label-position="inline"
      :label="$t('identification_id')"
      bottom-margin="small"
    >
      <div class="id-value">
        {{ identificationId }}
        &nbsp;
        <ui-button
          slot="reference"
          size="sm"
          @click="copy(identificationId)"
          :title="$t('copy_identification_url')"
        >
          <icon name="content-copy" />
        </ui-button>
      </div>
    </ui-field>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getters } from "@/store";
import { copy } from "@/utils/copy";
import { REJECT_REASON } from "@/constants";

export default {
  computed: {
    ...mapGetters([
      getters.currentIdentification,
      getters.currentIdentificationRejectionReason
    ]),
    identificationId() {
      return this.currentIdentification?.identificationId;
    },
    status() {
      return this.currentIdentification?.data?.status;
    },
    companyName() {
      return this.currentIdentification?.data?.companyName;
    },
    identificationStatus() {
      if (!this.status) {
        return "-";
      }

      return this.$t(`identification_status_value.${this.status}`);
    },

    rejectionReason() {
      if (!this.currentIdentificationRejectionReason) {
        return null;
      }

      const reasonValue =
        REJECT_REASON[this.currentIdentificationRejectionReason];

      return this.$t(`identification_reject_reasons.${reasonValue}`);
    }
  },
  methods: {
    copy(id) {
      const url = `${process.env.VUE_APP_BO_URL}/app/identifications/details/${id}`;
      copy(url);
    }
  }
};
</script>

<style scoped lang="scss">
.info-layout {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.company-name-field {
  span {
    font-size: 1.5rem;
  }
  .company-name {
    font-weight: bold;
    color: var(--black);
    background-color: var(--amber);
  }
}
.btn-icon {
  display: inline-block;
  width: 1.5rem;
  margin-left: 0.5rem;
}
.spacer {
  flex: 1 1 auto;
  height: 0;
}
.id-value {
  word-break: break-all;
}
</style>
